var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrella2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3044 20.087V29.1304C17.3044 31.8198 19.4845 34 22.1739 34C24.8633 34 27.0435 31.8198 27.0435 29.1304V28.4348M35.3913 18.6957H2C2 9.4749 9.4749 2 18.6957 2C27.9164 2 35.3913 9.4749 35.3913 18.6957Z",
    stroke: "#FF6A46",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella2);
export default __webpack_public_path__ + "static/media/umbrella2.9bf5817cf5483426ff921c9adb5ba10d.svg";
export { ForwardRef as ReactComponent };